import type { ReactNode } from 'react';
import { cn } from '@tark/shared/lib';

type CoachPageHeaderProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  meta?: ReactNode;
  action?: ReactNode;
  stats?: ReactNode;
  className?: string;
};

export default function CoachPageHeader({
  eyebrow = 'Coach Studio',
  title,
  subtitle,
  meta,
  action,
  stats,
  className,
}: CoachPageHeaderProps) {
  return (
    <section className={cn('rounded-lg border border-border bg-white shadow-[var(--shadow-card)]', className)}>
      <div className="flex flex-col gap-5 p-4 md:p-5 lg:flex-row lg:items-end lg:justify-between">
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">{eyebrow}</p>
          <div className="mt-2 flex flex-wrap items-center gap-3">
            <h1 className="text-3xl font-semibold tracking-tight text-text sm:text-4xl">{title}</h1>
            {meta}
          </div>
          {subtitle ? (
            <p className="mt-2 max-w-3xl text-sm font-medium leading-6 text-text-muted md:text-base">{subtitle}</p>
          ) : null}
        </div>
        {action ? <div className="flex shrink-0 flex-wrap items-center gap-2">{action}</div> : null}
      </div>
      {stats ? <div className="border-t border-border bg-surface/40 px-4 py-3 md:px-5">{stats}</div> : null}
    </section>
  );
}
